<template lang="pug">
  ProgramSettingsFormWrapper(
    :form-data="formData"
    :disable-save.sync="disableSave"
    :keys-to-reset="keysToReset"
    title="Program Contact Information"
    tooltip-text="Set specific members for contact with Be Well support."
  )
    ContentLoader(:height="180" v-if="!programLoaded")
      rect(x="0", y="0", rx="4", ry="4", width="48%", height="18%")
      rect(x="50%", y="0", rx="4", ry="4", width="48%", height="18%")
      rect(x="0", y="28%", rx="4", ry="4", width="48%", height="18%")
      rect(x="50%", y="28%", rx="4", ry="4", width="48%", height="18%")
      rect(x="0", y="54%", rx="4", ry="4", width="48%", height="18%")
      rect(x="50%", y="54%", rx="4", ry="4", width="48%", height="18%")
      rect(x="0", y="82%", rx="4", ry="4", width="48%", height="18%")
      rect(x="50%", y="82%", rx="4", ry="4", width="48%", height="18%")
    template(v-else)
      .is-block
        BField(
          label="Primary Contact"
          label-for="primaryContact"
          :type="{ 'is-danger': errors.has('primary contact') }"
          :message="errors.first('primary contact')"
        )
          BInput#primaryContact(
            name="primary contact"
            type="email"
            v-validate="'email'"
            v-model="primaryContact"
            expanded
            placeholder="primary@site.com"
            @input="disableSave = isOriginalValue('primaryContact', primaryContact)"
          )

        BField(
          label="Secondary Contact"
          label-for="secondaryContact"
          :type="{ 'is-danger': errors.has('secondary contact') }"
          :message="errors.first('secondary contact')"
        )
          BInput#secondaryContact(
            name="secondary contact"
            type="email"
            v-validate="'email'"
            v-model="secondaryContact"
            expanded
            placeholder="secondary@site.com"
            @input="disableSave = isOriginalValue('secondaryContact', secondaryContact)"
          )

        BField(
          label="Billing Contact"
          label-for="billingContact"
          :type="{ 'is-danger': errors.has('billing contact') }"
          :message="errors.first('billing contact')"
        )
          BInput#billingContact(
            name="billing contact"
            type="email"
            v-validate="'email'"
            v-model="billingContact"
            expanded
            placeholder="billing@site.com"
            @input="disableSave = isOriginalValue('billingContact', billingContact)"
          )

        BField(
          label="Decision Maker"
          label-for="decisionMaker"
          :type="{ 'is-danger': errors.has('decision maker') }"
          :message="errors.first('decision maker')"
        )
          BInput#decisionMaker(
            name="decision maker"
            type="email"
            v-validate="'email'"
            v-model="decisionMaker"
            expanded
            placeholder="descision_maker@site.com"
            @input="disableSave = isOriginalValue('decisionMaker', decisionMaker)"
          )
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";
import ProgramSettingsFormWrapper from "@@/ProgramSettingsAdmin/ProgramSettingsFormWrapper";
import WtLabel from "@@/WtLabel/WtLabel";
import { ContentLoader } from "vue-content-loader";

export default {
  name: "ContactInformation",

  components: { ProgramSettingsFormWrapper, ContentLoader, WtLabel },

  mixins: [programSettingsFormMixin],

  computed: {
    ...mapGetters("program", [
      "coreProgramMeta",
      "programSettingsCopy",
      "programLoaded"
    ]),

    formData() {
      return {
        primaryContact: this.primaryContact,
        secondaryContact: this.secondaryContact,
        billingContact: this.billingContact,
        decisionMaker: this.decisionMaker
      };
    },

    keysToReset() {
      return [
        "primaryContact",
        "secondaryContact",
        "billingContact",
        "decisionMaker"
      ];
    },

    primaryContact: {
      set(primaryContact) {
        this.updateProgramSettingsCopy({
          key: "primaryContact",
          value: primaryContact
        });
      },
      get() {
        return this.programSettingsCopy.primaryContact;
      }
    },

    secondaryContact: {
      set(secondaryContact) {
        this.updateProgramSettingsCopy({
          key: "secondaryContact",
          value: secondaryContact
        });
      },
      get() {
        return this.programSettingsCopy.secondaryContact;
      }
    },

    billingContact: {
      set(billingContact) {
        this.updateProgramSettingsCopy({
          key: "billingContact",
          value: billingContact
        });
      },
      get() {
        return this.programSettingsCopy.billingContact;
      }
    },

    decisionMaker: {
      set(decisionMaker) {
        this.updateProgramSettingsCopy({
          key: "decisionMaker",
          value: decisionMaker
        });
      },
      get() {
        return this.programSettingsCopy.decisionMaker;
      }
    }
  },

  methods: {
    ...mapActions("program", ["updateProgramSettingsCopy"])
  }
};
</script>

<style lang="sass" scoped></style>
